import { useContext, useState } from "react";
import { AppContext } from "../../../context/AppContext";
import useHttp from "../../../hooks/useHttp";
import { Button } from "antd";

function RefreshLicenseDetails(props) {
    const { usersTabRefreshBtn } = props;
    const [appProperties, setAppProperties] = useContext(AppContext);
    const [loading, setLoading] = useState(false);
    const { fetchData } = useHttp();
    const getLicenseDetails = () => {
        setLoading(true);
        fetchData(
            `omni/license?leftServiceId=${appProperties.leftServiceId}&osyncId=${appProperties.osyncId}`,
            "GET",
            null,
            appProperties
        )
            .then((response) => {
                response = JSON.parse(response);
                var license = response.data;
                appProperties.licenseObj.licenseDetails = license;
                setAppProperties((prev) => ({ ...prev, licenseObj: license }));
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };
    return (
        <>
            <Button
                rootClassName="refresh-btn"
                className="actionIconsSprite refresh-icon refreshIconHover p-1"
                loading={loading}
                onClick={getLicenseDetails}
                style={{
                    border: "none",
                    marginTop: usersTabRefreshBtn ? "" : "2px",
                    marginRight: usersTabRefreshBtn ? "" : "0px",
                }}
            ></Button>
        </>
    );
}

export default RefreshLicenseDetails;
